import { useCallback, useState } from "react"
import { Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { MdCheck, MdClose, MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md"
import { useHistory } from "react-router-dom"
import { toast } from "react-toastify"
import { ICardObjectResponseProps } from "../../models/ICardObjectResponse"
import { removeFavorite } from "../../services/favorites.service"
import handleCardAgroup from "../../utils/handleCardAgroup/handleCardAgroup"
import { ButtonFavorite } from "../button-favorite"
import { ButtonInterest } from "../button-interest"
import { CopyComponent } from "../copy-button"
import { Container, Details, DetailsButton, HiddenRow, Main } from "./styles"

export const FlatCardObject: React.FC<ICardObjectResponseProps> = ({ object, detailsMode = false, managerMode = false }) => {
    const { t: translation } = useTranslation();

    const history = useHistory()
    const [isExpanded, setIsExpanded] = useState<boolean>(false)

    const handleRemoveFavorite = (id: number) => {
        removeFavorite(id).then(() => {
            toast.success('Material removido com sucesso!', {
                position: "bottom-center",
            })
        }).catch((err: any) => {
            toast.error('Ocorreu um erro ao remover este material.')
        })
    }

    const handleCardDetails = useCallback((e: any) => {
        let url = '/objects/'
        if (managerMode) {
            url = '/manager/material/media/'
        }

        if (!e.button) {
            history.push(url + object.id);
        } else {
            window.open(url + object.id)
        }
    }, [object.id, history, managerMode])

    return (
        <Container style={detailsMode ? { boxShadow: '0px 2px 4px 0px rgba(204, 204, 204, 0.5)' } : { boxShadow: '0' }}>
            <Main style={{ maxHeight: isExpanded ? 300 : 110, }}>
                <Row className="mb-1">
                    <Col lg={11}>
                        <Row>
                            <Col lg={12} onMouseDown={(e) => handleCardDetails(e)} data-testid="card" style={{ cursor: 'pointer' }}>
                                <Row>
                                    <div className="mb-2" style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
                                        {object.category.category_icon ? (
                                            <em className={`material-icons-${object.category.category_icon}`}>{object.category.category_icon.split(' ')[1]}</em>
                                        ) : (
                                            <em className="material-icons-outlined sticky_note_2">sticky_note_2</em>
                                        )}
                                        <span>{object.category.title}</span>

                                    </div>
                                    <h2 className="mb-2" >
                                        <OverlayTrigger placement="top" overlay={<Tooltip>{detailsMode ? object.title : !!object.item ? object.item : object.title}</Tooltip>}>
                                            <div className="d-inline">{detailsMode ? object.title : !!object.item ? object.item : object.title}</div>
                                        </OverlayTrigger>
                                    </h2>
                                </Row>
                            </Col>
                        </Row>

                        <Row lg={6}>
                            <Col lg={3}>
                                <p className="mb-2"><b>{translation('components.card-news.Code')}:</b> {object.code ? object.code : translation('userAccount.uninformed')}</p>
                            </Col>
                            <Col lg={4}>
                                <p className="mb-2"><b>{translation('components.card-news.Discipline')}:</b> {object.discipline ? object.discipline : translation('userAccount.uninformed')}</p>
                            </Col>
                            <Col lg={4}>
                                <p className="mb-2"><b>{translation('components.card-news.Deadline')}:</b> {object.deadline ? object.deadline > 1 ? '20 Dias' : 'Pronta Entrega' : translation('userAccount.uninformed')}</p>
                            </Col>
                        </Row>
                    </Col>

                    <Col lg={1}>
                        <div className="utilsButtons">

                            <ButtonFavorite material={object} isMaterialView={false} removeFavorite={() => handleRemoveFavorite(object.favorite_id)} />


                            {object.deadline === 1 ? (
                                <CopyComponent ownsMaterial={object.owns_discipline} onCopy={() => { }} copyText={`${object.id}`} />
                            ) : (
                                <ButtonInterest id={object.id} interesting={object.interesting} />
                            )}

                        </div>
                    </Col>
                </Row>
                <HiddenRow>
                    <Col lg={12} style={{ textAlign: 'center' }}>
                        {isExpanded ? (
                            <DetailsButton onClick={() => { setIsExpanded(false) }} >
                                <MdKeyboardArrowUp size={28} />
                            </DetailsButton>
                        ) : (
                            <DetailsButton onClick={() => { setIsExpanded(true) }} >
                                <MdKeyboardArrowDown size={28} />
                            </DetailsButton>
                        )}
                    </Col>
                </HiddenRow>
            </Main>
            {isExpanded && (
                <Details >
                    {object.delivery_values.length ? (
                        <Row>
                            {handleCardAgroup(object.delivery_values, 3).map((item: any[], itemIndex) => (
                                <Col lg='auto' key={itemIndex}>
                                    {item.map((_item) => (
                                        <p className="mb-2" key={_item.title}>
                                            <b>{_item.title}: </b>
                                            {_item.value === 'True' ? <MdCheck color='#14CC70' size={17} /> : _item.value === 'False' ? <MdClose color='#FF4949' size={17} /> : !!_item.value ? _item.value : translation('userAccount.uninformed')}
                                        </p>
                                    ))}
                                </Col>
                            ))}

                        </Row>
                    ) : (
                        <p>{translation('userAccount.uninformed')}</p>
                    )}


                </Details>
            )}

        </Container>
    )
}
